export enum HttpRequestStatus {
    NONE = "none",
    PENDING = "pending",
    RESOLVED = "resolved",
    REJECTED = "rejected",
}
